export enum ComposerMode {
  LoadingIndex,
  Start,
  LoadingClipbook,
  ImportingPicture,
  NewPage,
  Editing,
}

export enum ComposerEditingMode {
  ZoomAndPan,
  Drawing,
}

export interface Page {
  uniqueID: string;
  backgroundID: string;
  width: number;
  height: number;
}

export enum BuiltinBackground {
  Blank = 'blank',
}

export function isBuiltinBackground(id: string) {
  return Object.keys(BuiltinBackground).some(key => id === BuiltinBackground[key as any]);
}

export interface ClipbookState {
  readonly id: string;
  readonly name: string;
  readonly pages: ReadonlyArray<Page>;
  readonly currentPage: number | null;
}

export interface PagePicture {
  blob: Blob;
  url: string;
}
